export default __webpack_public_path__ + "static/downtown-2cb55b426ab72921d8911e03e6889fab.jpg";